/** Shared loading UI helpers — uses existing .spinner styles. */

export function loadingMarkup(message = 'Loading…', size = '') {
    const sizeClass = size ? ` spinner-${size}` : '';
    return `
      <div class="inline-loading" role="status" aria-live="polite">
        <div class="spinner${sizeClass}" aria-hidden="true"></div>
        <p>${message}</p>
      </div>`;
}

export function setAppGridLoading(isLoading, message = 'Loading your apps…') {
    const grid = document.getElementById('app-grid');
    const empty = document.getElementById('app-grid-empty');
    const loading = document.getElementById('app-grid-loading');
    if (!loading) {
        return;
    }

    if (isLoading) {
        loading.querySelector('p').textContent = message;
        loading.classList.remove('is-hidden');
        grid?.classList.add('is-hidden');
        empty?.classList.add('is-hidden');
        return;
    }

    loading.classList.add('is-hidden');
}

export function tableLoadingRow(colspan, message = 'Loading…') {
    return `<tr class="admin-loading-row"><td colspan="${colspan}">${loadingMarkup(message, 'sm')}</td></tr>`;
}
